module.exports = __webpack_public_path__ + "img/organic-tea.5e21372c.svg";